exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 27
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_wks-ext.js